<app-multimedia-choose-or-upload
  (chooseClickEvent)="handleChooseClickEvent($event)"
  (clearClickEvent)="handleClearClickEvent()"
  [allowedMimeTypes]="allowedMimeTypes"
  [allowedMultimediaTypes]="allowedMultimediaTypes"
  [disabled]="disabled()"
  [maxFileSize]="maxFileSize"
  [multimediaId]="multimediaId()" />
